import React from 'react';
import { StatutSirene } from './useVerificationSiret';
import './ChampSiret.css';

interface ChampSiretProps {
  id: string;
  valeur: string;
  onChange: (siret: string) => void;
  label?: React.ReactNode;
  placeholder?: string;
  /** Doublon Centralis ou erreur serveur : prend le pas sur le retour SIRENE. */
  erreur?: string;
  /** Controle en cours (unicite + SIRENE) : spinner a droite du champ. */
  chargement?: boolean;
  /** Seul « indisponible » affiche un message : une adresse trouvee se voit, un SIRET inconnu se saisit. */
  statutSirene?: StatutSirene | null;
  inputRef?: React.RefObject<HTMLInputElement>;
}

/**
 * Saisie d'un SIRET francais : 14 chiffres, rien d'autre.
 *
 * Le bouton d'inscription reste grise tant que le formulaire est invalide, donc le navigateur
 * n'affiche son message sur le motif qu'au clic sur ce bouton grise : pendant la frappe, le
 * compteur est le seul retour visible. Il dit « 9 / 14 » a celui qui a colle un SIREN.
 */
const ChampSiret: React.FC<ChampSiretProps> = ({
  id,
  valeur,
  onChange,
  label = 'SIRET',
  placeholder = 'Ex : 12345678901234',
  erreur,
  chargement = false,
  statutSirene = null,
  inputRef,
}) => {
  const complet = valeur.length === 14;

  return (
    <div className="form-group champ-siret">
      <label htmlFor={id}>{label}<span style={{ color: 'red' }}>*</span></label>
      <div className="champ-siret-saisie">
        <input
          ref={inputRef}
          type="text"
          id={id}
          name="siret"
          value={valeur}
          onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 14))}
          placeholder={placeholder}
          inputMode="numeric"
          autoComplete="off"
          maxLength={14}
          minLength={14}
          pattern="^\d{14}$"
          title="Le SIRET comporte 14 chiffres"
          required
          className={erreur ? 'input-error' : ''}
        />
        <span className="champ-siret-indicateurs">
          {chargement && <span className="champ-siret-spinner" aria-hidden="true" />}
          <span className={`champ-siret-compteur${complet ? ' champ-siret-compteur-complet' : ''}`}>
            {valeur.length} / 14 chiffres
          </span>
        </span>
      </div>
      {erreur && <span className="error-message">{erreur}</span>}
      {!erreur && statutSirene === 'indisponible' && (
        <p className="champ-siret-retour champ-siret-retour-alerte">
          Adresse non récupérée depuis le répertoire SIRENE : elle sera à saisir manuellement.
        </p>
      )}
    </div>
  );
};

export default ChampSiret;
